import * as yup from "yup";

export const registerValidationSchema = yup.object().shape({
  first_name: yup
    .string()
    .required("is required")
    .min(2, "must be at least 2 characters"),
  last_name: yup
    .string()
    .required("is required")
    .min(2, "must be at least 2 characters"),
  email: yup.string().required("is required").email("not valid"),
  password: yup
    .string()
    .required("is required")
    .min(8, "must be at least 8 characters")
    .matches(/(?=.*[a-z])/, "must contain at least one lowercase letter")
    .matches(/(?=.*[A-Z])/, "must contain at least one uppercase letter")
    .matches(/(?=.*\d)/, "must contain at least one number")
    .matches(/(?=.*[@$!%*?&])/, "must contain at least one special character"),
  confirmPassword: yup
    .string()
    .required("is required")
    .oneOf([yup.ref("password")], "must match with password"),
  Phone_number: yup.string().matches(/^\d{10}$/, "must be exactly 10 digits"),
  // username: yup
  //   .string()
  //   .required("is required")
  //   .min(3, "must be at least 3 characters")
  //   .matches(/^\S*$/, "must not contain spaces"),
});
